import { render, staticRenderFns } from "./SharedCollectionDetail.vue?vue&type=template&id=6ef01525"
import script from "./SharedCollectionDetail.vue?vue&type=script&lang=js"
export * from "./SharedCollectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports